import React, { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { Bank, Upload, NutFill } from 'react-bootstrap-icons';
import '../styles/tables.css';
import CustomToggle from '../styles/customToggle';
import CrearBancoModal from './componentes/crearBancoModal';
import TablaBancos from './componentes/tablaBancos';
import SaldoPendienteModal from './componentes/SaldoPendienteModal'; // Modal para saldo pendiente

function AdminBancos() {
  // Estado para los modales
  const [showNuevoBanco, setShowNuevoBanco] = useState(false);
  const [showSaldoPendiente, setShowSaldoPendiente] = useState(false);

  // Funciones para abrir y cerrar los modales
  const handleCloseNuevoBanco = () => setShowNuevoBanco(false);
  const handleShowNuevoBanco = () => setShowNuevoBanco(true);

  const handleCloseSaldoPendiente = () => setShowSaldoPendiente(false);
  const handleShowSaldoPendiente = () => setShowSaldoPendiente(true);

  return (
    <div className="mx-2 mt-3">
      <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
        <p className="mb-2 mb-md-0 text-center">
          Administra los ingresos y egresos en tus cuentas bancarias
        </p>
        <div className="d-flex mt-2 mt-md-0">
          <Button variant="danger" onClick={handleShowNuevoBanco}>
            <Bank /> Nuevo Banco
          </Button>
          <Button variant="dark" className='ms-2' onClick={handleShowSaldoPendiente}>
            <Bank /> Saldo Pendiente
          </Button>
        </div>
      </div>

      {/* Modal para crear bancos */}
      <CrearBancoModal show={showNuevoBanco} handleClose={handleCloseNuevoBanco} />

      {/* Modal para registrar saldo pendiente */}
      <SaldoPendienteModal show={showSaldoPendiente} handleClose={handleCloseSaldoPendiente} />

      {/* Tabla de Bancos */}
      <div className="mb-2 mt-4">
        <TablaBancos />
      </div>
    </div>
  );
}

export default AdminBancos;
